import React from 'react';

const BurgerMenu = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H24V24H0z' />
        <path
          fill='#FFF'
          d='M21.608 17.598c.415 0 .75.335.75.75s-.335.75-.748.75H2.39c-.415 0-.75-.335-.75-.75s.335-.75.75-.75h19.218zm0-6.35c.415 0 .75.334.75.75 0 .414-.335.75-.748.75H2.39c-.415 0-.75-.336-.75-.75 0-.416.335-.75.75-.75h19.218zm.002-6.346c.415 0 .75.335.75.75s-.335.75-.75.75H2.39c-.415 0-.75-.335-.75-.75s.335-.75.75-.75h19.22z'
        />
      </g>
    </svg>
  );
};

export default BurgerMenu;
